'use client';
import { jsx } from 'react/jsx-runtime';
import { Suspense } from 'react';
import { useUrlSearchParams } from './next.mjs';

function withSearchParams(WrappedComponent) {
    // Try to create a nice displayName for React Dev Tools.
    const displayName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    const ComponentWithSearchParams = (props)=>{
        // Fetch the props you want to inject. This could be done with context instead.
        const searchParams = useUrlSearchParams();
        // props comes afterwards so the can override the default ones.
        return /*#__PURE__*/ jsx(WrappedComponent, {
            ...props,
            searchParams: searchParams
        });
    };
    // Creating the inner component. The calculated Props type here is the where the magic happens.
    const ComponentWithTheme = (props)=>{
        // Fetch the props you want to inject. This could be done with context instead.
        // props comes afterwards so the can override the default ones.
        return /*#__PURE__*/ jsx(Suspense, {
            fallback: /*#__PURE__*/ jsx(WrappedComponent, {
                ...props,
                searchParams: new URLSearchParams()
            }),
            children: /*#__PURE__*/ jsx(ComponentWithSearchParams, {
                ...props
            })
        });
    };
    ComponentWithTheme.displayName = `withTheme(${displayName})`;
    return ComponentWithTheme;
}

export { withSearchParams as w };
